import { render, staticRenderFns } from "./PayStatus.vue?vue&type=template&id=fabd3d88&scoped=true"
import script from "./PayStatus.vue?vue&type=script&lang=js"
export * from "./PayStatus.vue?vue&type=script&lang=js"
import style0 from "./PayStatus.vue?vue&type=style&index=0&id=fabd3d88&prod&lang=scss"
import style1 from "./PayStatus.vue?vue&type=style&index=1&id=fabd3d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabd3d88",
  null
  
)

export default component.exports